import { RadioGroup } from "@headlessui/react";
import { t } from "@/i18n-js/instance";
import { Icon } from "@circle-react-shared/Icon";
import { Option } from "./Option";

export interface LightDarkRadioProps {
  name: string;
  onChange: (value: "light" | "dark") => void;
  value: "light" | "dark";
}

export const LightDarkRadio = ({
  value = "light",
  onChange,
  name,
  ...rest
}: LightDarkRadioProps) => (
  <RadioGroup
    value={value}
    onChange={onChange}
    className="flex w-full flex-wrap items-center gap-4"
    name={name}
    {...rest}
  >
    <Option value="light">
      <Icon type="20-sun" size={20} />
      {t("light")}
    </Option>
    <Option value="dark">
      <Icon type="20-moon" size={20} />
      {t("dark")}
    </Option>
  </RadioGroup>
);
